<template>
  <div class="add">
    <div class="diver"></div>
    <div v-loading="loading">
      <div class="addCard">
        <!-- :style="{ height: number + 'px' }" -->
        <el-form :model="formData" :inline="true" label-width="80px" :rules="rules" ref="formData">
          <div class="top">
            <h5>客户基本信息</h5>
            <div class="card">
              <el-form-item label="日期" prop="sknDate">
                <el-date-picker v-model="formData.sknDate" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="姓名" class="service" prop="name">
                <el-input clearable @input="testSX" v-model="formData.name" placeholder="请输入客户姓名"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="mobile">
                <el-input clearable @input="testSX" v-model="formData.mobile" placeholder="请输入电话号码" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
              </el-form-item>
              <el-form-item label="院区" prop="earId">
                <div class="special">
                  <el-select clearable v-model="formData.earId" placeholder="请选择" ref="earId" @change="earChange">
                    <el-option v-for="item in areaAndFloorList" :key="item.id" :label="item.areaName" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="楼层" prop="sknFloor">
                <div class="special">
                  <el-select clearable v-model="formData.sknFloor" placeholder="请选择楼层">
                    <el-option v-for="item in formData.floorOptions" :key="item.id" :label="item.floorName" :value="item.floorName">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="初/复诊" prop="status">
                <div class="special">
                  <el-select clearable v-model="formData.status" placeholder="请选择初/复诊">
                    <el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="病历号" prop="caseCode">
                <el-input clearable v-model="formData.caseCode" placeholder="请输入病历号" oninput="value=value.replace(/[\u4E00-\u9FA5]/g, '')"></el-input>
              </el-form-item>
              <el-form-item label="客户标签" prop="flag">
                <el-select clearable v-model="formData.flag" placeholder="客户标签">
                  <el-option v-for="item in flagOption" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="信息来源" prop="informationSource">
                <el-select clearable filterable :disabled="formData.information == 0 ? true : false" v-model="formData.informationSource" placeholder="请选择信息来源">
                  <el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.sourceName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <div class="special">
                  <el-select @input="testSX" v-model="formData.sex" clearable placeholder="请选择性别">
                    <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="年龄">
                <div class="special">
                  <el-input clearable v-model="formData.age" placeholder="请输入年龄"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="咨询师" prop="empName">
                <el-select @focus="focus" @keydown.enter.native="enterDoctor($event, 4)" default-first-option :filter-method="empMatch" @input="testSX" v-model="formData.empName" ref="empName" clearable placeholder="请选择咨询师" filterable remote allow-create>
                  <el-option v-for="item in newList3" :key="item.id" :label="item.empName" :value="item.empName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="卡号" prop="cadCode">
                <el-input clearable v-model="formData.cadCode" placeholder="请输入卡号" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
              </el-form-item>
              <el-button class="info" type="primary" @click="getInfo" size="mini">获取客户信息及消费数据</el-button>
            </div>
            <!-- 购买信息 -->
            <purchase ref="purchase" :formData="formData" :purData="formData.purchaseInformationList" :projectData="formData.purchaseInformationDtoList" :status="formData.status"></purchase>

            <!-- 已购买项目信息 -->
            <project ref="project" @getProject="getProject(arguments[0],arguments[1],arguments[2])" :formData="formData" :projectData="formData.purchaseInformationDtoList" :aaData="aaData" :childData="formData.musInformationList" :refundData.sync="formData.refundInformationList" :counts="counts"></project>

            <!-- 划扣信息 -->
            <child ref="child" :childData="formData.musInformationList" :rowId='rowId' :formData="formData"></child>

            <!-- 退款信息 -->
            <refund ref="refund" :refundData.sync="formData.refundInformationList" :rowId='rowId'></refund>

            <!-- 注射信息 -->
            <inject ref="inject" :childInject="formData.injectionProjectList"></inject>
          </div>

          <!-- 客户历史消费信息 -->
          <collapse ref="collapse" @getData="getData(arguments[0],arguments[1])" :tableData="tableData" :filters="filters" :formData="formData"></collapse>

          <div class="flex">
            <el-form-item>
              <!-- <el-button type="danger" @click="back('formData')">取消</el-button> -->
              <el-button :disabled="disabled" type="primary" @click="onSubmit('formData')">确定</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- 选择信息弹框 -->
      <el-dialog center :visible.sync="dialogFormCheck" append-to-body>
        <info :projectData="formData.purchaseInformationDtoList" :loadOptions="loadOptions" @close="close" :formData="formData" @getData="getData(1,'get')" @getProject="getProject(arguments[0],arguments[1],arguments[2])"></info>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import child from "./child.vue";
import Info from "./info.vue";
import inject from "./inject.vue";
import collapse from "./collapse.vue";
import purchase from "./purchase.vue";
import project from "./project.vue";
import refund from "./refund.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: { child, Info, inject, collapse, purchase, project, refund },
  computed: {
    ...mapState([
      "statusOptions",
      "areaOptions",
      "nameOptions",
      "flagOption",
      "sexey",
    ]),
    ...mapGetters([
      "list3", 'list1', 'list2', 'list4',
      "productOptions",
      "sourceList",
      "areaAndFloorList", 'instructmentList'
    ]),
  },
  props: ["formData", "rowId"],
  data() {
    var checkPhone = (rule, value, callback) => {
      if (this.formData.earId == "001") {
        if (value) {
          let num = value.slice(2, value.length); //提取数字
          let str = value.slice(0, 2); //提取字母
          let p = /[a-z]/i;
          // 首先判断病历号前两位是否是TM/PF
          if (str != "TM" && str != "PF" && str != "KS") {
            callback(new Error("病历号格式不正确!"));
          } else if (str == "TM" || str == "PF" || str == "KS") {
            // 其次判断后面是否是八位数字
            if (num.length != 8) {
              callback(new Error("病历号长度不正确!"));
            } else {
              // 判断后八位格式是否都是数字
              if (p.test(num) == true) {
                callback(new Error("病历号格式不正确!"));
              } else {
                callback();
              }
            }
          }
        }
        callback();
      } else if (this.formData.earId == "003") {
        if (value) {
          let num = value.slice(2, value.length); //提取数字
          let str = value.slice(0, 2); //提取字母
          let p = /[a-z]/i;
          // 首先判断病历号前两位是否是TM/PF
          if (str != "TM" && str != "PF" && str != "KS") {
            callback(new Error("病历号格式不正确!"));
          } else if (str == "TM" || str == "PF" || str == "KS") {
            // 其次判断后面是否是八位数字
            if (num.length != 7) {
              callback(new Error("病历号长度不正确!"));
            } else {
              // 判断后八位格式是否都是数字
              if (p.test(num) == true) {
                callback(new Error("病历号格式不正确!"));
              } else {
                callback();
              }
            }
          }
        }
        callback();
      }
    };
    return {
      childData: {},
      refundData: {},
      childInject: {},
      tableData: [],
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
        name: '',
        cadCode: '',
        caseCode: '',
        projectName: '',
        musProjectName: '',
        musCode: '',
        doctorName: '',
        nurseName: '',
        injectionProjectName: '',
        injectionNurseName: '',
        startTime: "",
        endTime: "",
      },
      counts: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
      },
      dialogFormCheck: false,
      loadOptions: [],
      newData: [],
      newList1: [],
      newList2: [],
      newList4: [],
      dialog: true,
      newList3: [],
      rules: {
        sknDate: [{ required: true, message: "请选择日期", trigger: "blur" }],
        name: [{ required: true, message: "请添加姓名", trigger: "blur" }],
        mobile: [{ required: true, message: "请添加电话", trigger: "blur" }],
        earId: [{ required: true, message: "请选择院区", trigger: "blur" }],
        sknFloor: [{ required: true, message: "请选择楼层", trigger: "blur" }],
        status: [{ required: true, message: "请选择初复诊", trigger: "blur" }],
        caseCode: [{ required: true, message: "请输入病历号", trigger: "blur" }],
        flag: [{ required: true, message: "请选择客户标签", trigger: "blur" }],
        informationSource: [
          { required: true, message: "请选择信息来源", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        empName: [{ required: true, message: "请添加咨询师", trigger: "blur" }],
        cadCode: [{ required: true, message: "请添加卡号", trigger: "blur" }],
      },
      loading: false,
      projectData: [],
      aaData: [],
      disabled: false,
    };
  },
  created() {
    this.newList3 = this.$store.getters.list3;
    this.newList1 = this.$store.getters.list1;
    this.newList2 = this.$store.getters.list2;
    this.newList4 = this.$store.getters.list4;
    this.newData = this.$store.getters.productOptions;
    this.formData.status = "";
    this.formData.flag = "无";
    this.formData.sknDate = new Date();

    // 获取已购买项目
    busPhone.$on('list', val => { // 接收值
      // console.log(val);
      if (this.formData.purchaseInformationDtoList.length == 0) {
        this.formData.purchaseInformationDtoList = JSON.parse(JSON.stringify(val))
      } else if (this.formData.purchaseInformationDtoList.length != 0) {
        this.s = this.formData.purchaseInformationDtoList.map(x => x.purchaseId)
        val.forEach(item => {
          if (!this.s.includes(item.purchaseId)) {
            this.formData.purchaseInformationDtoList.push(item)
          } else if (this.s.includes(item.purchaseId)) {
            // 解决数据更新，el-table表格不更新
            this.itemKey = Math.random()
            // 如果有重复数据，替换当前数据
            this.formData.purchaseInformationDtoList.splice(this.formData.purchaseInformationDtoList.findIndex(list => list.purchaseId === item.purchaseId), 1, item);
          }
        });
      }
      // // 动态修改分页总条数
      this.counts.pagination.total = this.formData.purchaseInformationDtoList.length
      // 添加数据后表格排序
      // console.log(this.$refs.table);
      this.formData.purchaseInformationDtoList.sort(this.compare('residueNumber'))
    })
  },
  methods: {
    // 数值排序
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      }
    },
    testSX() {
      this.$forceUpdate();
    },

    earChange(val) {
      this.$nextTick(() => {
        this.formData.earName = this.$refs.earId.selected.label;
      });
      this.formData.sknFloor = "";
      let arr = this.areaAndFloorList;
      arr.forEach((ele) => {
        if (val == ele.id) {
          this.formData.floorOptions = ele.floorNameList;
        }
      });
      if (this.formData.earId == "") {
        this.formData.floorOptions = [];
      }
    },
    // 去除数组中的空值
    removeEmpty(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == "" || typeof arr[i] == "undefined") {
          arr.splice(i, 1);
          i = i - 1; // i - 1 ,因为空元素在数组下标 2 位置，删除空之后，后面的元素要向前补位
        }
      }
      return arr;
    },
    onSubmit(formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          // 给projectId、musProjectId\musProjectName\project赋值
          this.newData.forEach((item) => {
            this.formData.musInformationList.forEach((ele) => {
              if (ele.musProjectId == item.id) {
                ele.musProjectName = item.project;
              }
            });
            this.formData.purchaseInformationList.forEach((list) => {
              if (list.projectId == item.id) {
                list.project = item.project;
              }
            });
          });
          // 给doctorName、aideName、nurseName赋值
          this.formData.musInformationList.forEach((item) => {
            this.newList1.forEach(ele => {
              if (ele.identityName == item.doctorName) {
                item.doctorNo = ele.id
              }
            });
            this.newList2.forEach(ele => {
              if (item.nurseName == ele.identityName) {
                item.nurseNo = ele.id
              }
            });
            this.newList4.forEach(ele => {
              if (item.aideName == ele.identityName) {
                item.aideNo = ele.id
              }
            });
            // 仪器名称
            item.instruments.forEach(ele => {
              console.log(item.instrumentNo);
              if (item.instrumentNo == ele.id) {
                item.instrumentName = ele.instrumentName
              }
            });
          });
          this.formData.injectionProjectList.forEach((item) => {
            this.newList2.forEach(ele => {
              if (item.injectionNurseName == ele.identityName) {
                item.injectionNurseNo = ele.id
              }
            });
          })
          // sourceId是否有值
          if (this.formData.information == 1) {
            this.sourceList.forEach((ele) => {
              if (this.formData.informationSource == ele.sourceName) {
                this.formData.sourceId = ele.sourceId;
              }
            });
          } else if (this.formData.information == 0) {
            this.formData.sourceId = "";
          }
          console.log(this.formData.musInformationList);
          this.formData.musInformationList.forEach(item => {
            console.log(typeof (item.id));
            if (typeof (item.id) == 'string') {
              item.id = ''
            }
          });
          this.formData.createBy = Lockr.get("skinEmpId");
          this.disabled = true
          api.requestQuiet("/skn/createSknMaterial", this.formData, (res) => {
            if (res.result == true) {
              router.push({ path: "/instrument/instrument" });
              if (res.data != "") {
                _g.toast("success", "操作成功");
                this.$emit("close1");
                this.$emit("add-comment");
                this.$refs[formData].resetFields();
              }
            } else {
              _g.toast("error", res.errMsg);
            }
            this.disabled = false
          }, (err) => {
            this.disabled = false
          });
        } else {
          _g.toast("warning", "请完善信息");
          return false;
        }
      });
    },
    back(formData) {
      this.$emit("close1");
      this.$refs[formData].resetFields();
    },
    // 获取信息
    getInfo() {
      this.formData.age = "";
      this.formData.sex = "";
      this.formData.empName = "";
      // this.formData.informationSource = "";
      this.formData.flag = "";
      let data = {
        cadCode: this.formData.cadCode,
        name: this.formData.name,
        mobile: this.formData.mobile,
      };
      // information是否是宏脉数据0、是1、否
      api.requestQuiet("/skn/getClientInformation", data, (res) => {
        if (res.result == true) {
          this.formData.information = 0;
          this.dialogFormCheck = true;
          this.loadOptions = res.data.mapList;
        } else if (res.result == false) {
          //   获取信息之后是否可以编辑信息
          this.formData.information = 1;
          _g.toast("warning", "请手动添加客户信息");
          // 获取历史消费数据
          this.getData(1, 'get')
          // 获取已购买项目信息
          if (this.formData.purchaseInformationDtoList.length == 0) {
            this.getProject(1, this.formData.mobile.replace(/\//g, "/"), this.rowId)
          }
        }
      }, (err) => { });
    },

    close() {
      this.dialogFormCheck = false;
    },

    getData(page, val) {
      console.log(page, val);
      // console.log(this.formData);
      if (this.formData.mobile == "") {
        _g.toast("error", "电话号码不能为空!");
        return;
      }
      this.loading = true;
      this.newData = this.$store.getters.productOptions;
      // 控制子组件disabled状态
      this.$refs.child.sing();
      this.$refs.purchase.sing();
      var reg = /[\t\r\f\n\s]*/g;
      if (val == "get") {
        var querys = {
          name: this.formData.name.replace(reg, ''),
          mobile: this.formData.mobile.replace(/\//g, ","),
          cadCode: this.formData.cadCode,
          page: page,
          size: this.filters.pagination.limit,
        };
      } else if (val == "check") {
        let valName = this.$refs.collapse.filters;
        var querys = {
          mobile: this.formData.mobile.replace(/\//g, ","),
          page: page,
          size: this.filters.pagination.limit,
          name: valName.name.replace(reg, ''),
          cadCode: valName.cadCode,
          caseCode: valName.caseCode,
          projectName: valName.projectName,
          musProjectName: valName.musProjectName,
          musCode: valName.musCode,
          doctorName: valName.doctorName,
          nurseName: valName.nurseName,
          injectionProjectName: valName.injectionProjectName,
          injectionNurseName: valName.injectionNurseName,
          startTime: "",
          endTime: "",
        };
        if (valName.startTime) {
          querys.startTime = valName.startTime[0];
          querys.endTime = valName.startTime[1];
        }
      }
      console.log(querys.name);
      api.request("/skn/getClientConsumeInformation", querys, (res) => {
        if (res.result == true) {
          this.loading = false;
          var data = res.data.list;
          this.tableData = data;
          this.filters.pagination.total = parseInt(res.data.count);
          if (this.tableData.length == 0) {
            _g.toast("warning", "暂无历史数据");
            // if (!this.rowId) {
            this.formData.status = "1";
            // }
          } else if (this.tableData.length != 0) {
            // if (!this.rowId) {
            this.formData.status = "2";
            // }
          }
        }
      }, (res) => {
        this.loading = false;
      });
    },
    // 获取已购买项目信息
    getProject(page, mobile, sknId) {
      let querys = {
        mobile: mobile,
        // page: page,
        // size: this.counts.pagination.limit,
        sknId: sknId,
      };
      api.request("/skn/getPurchaseInformation", querys, (res) => {
        if (res.result == true) {
          this.loading = false;
          var data = res.data.list;
          this.$nextTick(() => { // 请求成功之后，在这里执行
            this.formData.purchaseInformationDtoList = data;
            // 数据分页
            this.allData = data
            this.counts.pagination.total = parseInt(res.data.count);
            this.aaData = this.allData.slice((page - 1) * this.counts.pagination.limit, page * this.counts.pagination.limit)
            this.aaData.forEach((el, i) => {
              el.$index = (page - 1) * this.counts.pagination.limit + 1 + i;
            });
          })
          // if (this.formData.purchaseInformationDtoList.length == 0) {
          //   _g.toast("warning", "暂无已购买项目信息");
          // }
        }
      }, (res) => {
        this.loading = false;
      });
    },
    enterDoctor(e, val, index) {
      if (val == 4) {
        //咨询师
        if (this.newList3[0] != undefined) {
          this.formData.empName = this.newList3[0].empName;
          this.$forceUpdate();
          this.$refs.empName.blur();
        }
      }
    },
    focus() {
      this.newList3 = this.list3;
    },
    empMatch(val) {
      this.newList3 = _g.paramMatch(this.list3, this.newList3, val, 'empName')
    },
  },
};
</script>
<style scoped>
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}
.card >>> .el-select .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
}
.card >>> .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.special >>> .el-select .el-input__inner {
  width: 82px;
}
.special >>> .el-input__inner {
  width: 82px;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}

.add >>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #dcdfe6;
}
.cardNum {
  color: #f56c6c;
  font-size: 12px;
}
.musCode >>> .el-input__inner {
  border-color: #f56c6c;
}
.add >>> .el-form-item {
  margin-bottom: 3px !important;
}
.top {
  height: 600px;
  overflow: scroll;
}
.diver {
  width: 100%;
  height: 1px;
  border-top: 1px solid #dcdfe6;
  margin: 10px 0;
}
</style>
